// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	if(document.getElementsByClassName('js-proposal-cta').length > 0){
		let allCtas = document.getElementsByClassName('js-proposal-cta');
		for(let i=0; i < allCtas.length; i++){
			allCtas[i].addEventListener('click', function(e){
				e.preventDefault();

				if(document.getElementById('formContainer').classList.contains('open')){
					document.getElementById('formContainer').classList.remove('open');
					this.getElementsByTagName('span')[0].innerHTML = 'Request Proposal';
				} else {
					document.getElementById('formContainer').classList.add('open');
					this.getElementsByTagName('span')[0].innerHTML = 'Close';
				}
			})
		}
	}
	
	

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');
		if(document.getElementById('home')){
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		} else {
			document.getElementById('header').classList.add('down');
		}
		
	};

	if(document.getElementsByClassName('js-burger-menu').length > 0){
		let allBurger = document.getElementsByClassName('js-burger-menu');
		let allBurgerLenth = allBurger.length;
		for(let i = 0; i < allBurgerLenth; i++){
			allBurger[i].addEventListener('click', function(){
				if(document.getElementById('header').classList.contains('open')){
					document.getElementById('header').classList.remove('open')
				} else {
					document.getElementById('header').classList.add('open')
				}
			})
		}
	}

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
	} else {
		if(document.getElementById('header').classList.contains('down')){

			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}